'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _merge2 = require('lodash/merge');

var _merge3 = _interopRequireDefault(_merge2);

var _smoothScroll = require('smooth-scroll');

var _smoothScroll2 = _interopRequireDefault(_smoothScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

strip.$inject = ['ApiService'];


var _ = {
    merge: _merge3.default
};

var _module = angular.module('cb.strips.cbStrip', []);

_module.directive('strip', strip);

exports.default = _module;


function strip(ApiService) {
    return {
        restrict: 'C',
        link: cbStripLink
    };

    function cbStripLink(scope, element, attr) {
        var _gettersAndSetters = addGettersAndSetters(element);
        var gettersAndSetters = ApiService.registerGettersAndSetters(_gettersAndSetters);

        var cbFunctions = getCbFunctions(element);

        cbFunctions = _.merge(cbFunctions, gettersAndSetters);

        ApiService.attach({
            'strip': cbFunctions
        });
    }
}

/* Define getters and setters, used in cb-functions
 * Usage:
 *  cb('strip', 'set', [index], {
 *     display: ...
 * });
 *
 * To use the getter in code blocks
 * var x;
 * cb('strip', 'get', [index], (strip) => { x = strip; });
 */
function addGettersAndSetters(element) {
    var strip = {};

    Object.defineProperty(strip, 'display', {
        get: function get() {
            return $(element).css('display');
        },
        set: function set(newValue) {
            return $(element).css('display', newValue);
        }
    });

    return strip;
}

/* Define getters and setters, used in cb-functions
 * Usage:
 *  cb('strip', 'scrollTo', [index]);
 */
function getCbFunctions(element) {

    var scroll = new _smoothScroll2.default();

    return {
        'scrollTo': function scrollTo() {
            window.requestAnimationFrame(function () {
                if (element) {
                    scroll.animateScroll(element[0]);
                }
            });
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/strip.directive.js
// module id = 958
// module chunks = 1